import { Responsive, WidthProvider } from 'react-grid-layout';
import styled from 'styled-components';

import { ROW_CONTAINER_HEIGHT } from './RGEditLayout';
import { sortLayoutByY, transformLgToXxs } from './layoutTransformers';

const _ResponsiveGridLayout = WidthProvider(Responsive);
const ResponsiveGridLayout = _ResponsiveGridLayout as unknown as React.FC<any>;

const GridStyles = styled('div')`
  .grid-container {
    display: flex;

    justify-content: center;
    align-items: center;
  }

  .react-grid-item {
    border: 1px solid transparent;
  }

  .selected {
    border: 2px solid #cc0aac;
    border-radius: 5px;
    box-shadow: 0 0 10px #cc0aac;
  }

  .react-resizable-hide .react-resizable-handle {
    display: none !important;
  }

  .react-grid-drag-handle {
    cursor: move;
  }
`;

const RGPreviewLayout = (props: { components: any; layouts: any }) => {
  const xxsLayout = transformLgToXxs(props.layouts);
  const sortedLayout = sortLayoutByY(props.layouts?.lg ?? []);

  const layouts = { lg: sortedLayout, sm: sortedLayout, xs: sortedLayout, xxs: xxsLayout };

  return (
    <GridStyles>
      <ResponsiveGridLayout
        className="layout"
        rowHeight={ROW_CONTAINER_HEIGHT}
        breakpoints={{ lg: 1200, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, sm: 12, xs: 12, xxs: 1 }}
        isResizable={false}
        isDraggable={false}
        preventCollision={true}
        margin={[0, 0]}
        layouts={layouts}
      >
        {props.components.map((_c: any) => (
          <div key={_c.id}>{_c.component}</div>
        ))}
      </ResponsiveGridLayout>
    </GridStyles>
  );
};

export { RGPreviewLayout };
